AFRAME.registerComponent("account-input", {
    schema: {
        expandable: { default: false }
    },

    init: function() {
        this.inputAframe = this.el.querySelector('.aframe-input');
        this.inputHtml = this.el.querySelector('input');
        this.placeholderText = this.el.getAttribute('placeholder') || '';

        if (this.data.expandable) {
            this.inputBg = this.el.querySelector('a-rounded-box[data-raycastable]');
            const popup = this.el.parentNode;
            this.popupBg = popup ? popup.querySelector('.popup-bg') : null;
            const closeBtn = popup ? popup.querySelector('.close-button') : null;
            this.closeButtonWrapper = closeBtn ? closeBtn.parentNode : null;
            this.htmlEntity = this.el.querySelector('[html]');
            this._inputExpanded = false;
        }

        this.createFrame();
        this.setListeners();

        if (this.data.expandable) {
            this._sizeObserver = new MutationObserver(() => {
                this.updateSize(this.inputHtml.getAttribute('value') || '');
            });
            this._sizeObserver.observe(this.inputHtml, { attributes: true, attributeFilter: ['value'] });
            this.updateSize(this.inputHtml.value || this.inputHtml.getAttribute('value') || '');
        }
    },

    remove: function() {
        if (this._sizeObserver) {
            this._sizeObserver.disconnect();
            this._sizeObserver = null;
        }
    },

    setListeners: function() {
        this.inputHtml.addEventListener('focus', (e) => {
            const currentText = e.target.value
            if (currentText === this.placeholderText) {
                this.inputHtml.value = ''
            } else {
                const len = e.target.value.length;
                e.target.setSelectionRange(len, len);
            }
            if (this.focusBorder) this.focusBorder.setAttribute('visible', true);
        })
        this.inputHtml.addEventListener('input', (e) => {
            const len = e.target.value.length;
            e.target.setSelectionRange(len, len);
            if (this.data.expandable) this.updateSize(e.target.value);
        })
        this.inputHtml.addEventListener('blur', (e) => {
            const currentText = e.target.value
            if (currentText === '') {
                this.inputHtml.value = this.placeholderText
                this.inputHtml.classList.add(`updated-${new Date().getTime()}`)
            }
            if (this.focusBorder) this.focusBorder.setAttribute('visible', false);
        })

        if (this.inputAframe) {
            this.inputAframe.addEventListener('click', () => {
                if (this.inputHtml.value === this.placeholderText) {
                    this.inputHtml.value = ''
                    this.inputHtml.classList.add(`updated-${new Date().getTime()}`)
                }
            })
        }
    },
    
    updateSize: function(text) {
        const textStr = text || '';
        const baseInputWidth = 3;
        const basePopupBgWidth = 3.6;
        const baseCssWidth = 680;
        const minChars = 22;
        const charWidth = 0.115;

        let extraWidth = 0;
        if (textStr.length > minChars) {
            extraWidth = (textStr.length - minChars) * charWidth;
        }

        const targetInputWidth = baseInputWidth + extraWidth;

        if (this.inputBg) {
            this.inputBg.setAttribute('width', targetInputWidth);
        }
        if (this.popupBg) {
            this.popupBg.setAttribute('width', basePopupBgWidth + extraWidth);
        }
        if (this.focusBorder) {
            this.focusBorder.setAttribute('width', targetInputWidth + 0.06);
        }
        if (this.closeButtonWrapper) {
            this.closeButtonWrapper.setAttribute('position', `${1.5 + extraWidth / 2} 1.47 0.01`);
        }

        if (extraWidth > 0) {
            const newCssWidth = Math.round(baseCssWidth * (targetInputWidth / baseInputWidth));
            if (this.inputHtml.style.width !== newCssWidth + 'px') {
                this.inputHtml.style.width = newCssWidth + 'px';
                const htmlComp = this.htmlEntity && this.htmlEntity.components && this.htmlEntity.components.html;
                if (htmlComp) htmlComp.update();
            }
            this._inputExpanded = true;
        } else if (this._inputExpanded) {
            this.inputHtml.style.width = '';
            const htmlComp = this.htmlEntity && this.htmlEntity.components && this.htmlEntity.components.html;
            if (htmlComp) htmlComp.update();
            this._inputExpanded = false;
        }
    },

    createFrame: function () {
        let width = 3.06;
        let height = 0.46;
        let position = '1.5 -0.4 -0.005';
        const originalInputBg = this.el.querySelector('.input-background')
        if (originalInputBg) {
            width = parseFloat(originalInputBg.getAttribute('width')) + 0.06 || width
            height = parseFloat(originalInputBg.getAttribute('height')) + 0.06|| height
            const originalPosition = originalInputBg.getAttribute('position')
            if (originalPosition) {
                const [x, y, z] = originalPosition
                position = `${x} ${y} ${z - 0.005}`;
            }
        }
        
        this.focusBorder = document.createElement('a-rounded-box');
        this.focusBorder.setAttribute('width', width);
        this.focusBorder.setAttribute('height', height);
        this.focusBorder.setAttribute('depth', 0.001);
        this.focusBorder.setAttribute('color', '#3636E3');
        this.focusBorder.setAttribute('opacity', 0.999);
        this.focusBorder.setAttribute('position', position);
        this.focusBorder.setAttribute('radius', 0.1);
        this.focusBorder.setAttribute('visible', false);
        this.el.appendChild(this.focusBorder);
    },
})